import { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

export const MessageContainer = ({ children }: { children: ReactNode }) => (
    <Box component={Grid} item xs={12} sx={{ px: '12px', py: '4px' }}>
        {children}
    </Box>
);
